import createAxios from '/@/utils/axios'
import { useUserInfo } from '/@/stores/userInfo'

export const userUrl = '/api/user/'
export const accountUrl = '/api/account/'

export function checkIn(method: 'get' | 'post', params: object = {}) {
    return createAxios({
        url: userUrl + 'checkIn',
        data: params,
        method: method,
    })
}

export function overview() {
    return createAxios({
        url: accountUrl + 'overview',
        method: 'get',
    })
}

export function postProfile(params: anyObj) {
    return createAxios(
        {
            url: accountUrl + 'profile',
            method: 'POST',
            data: params,
        },
        {
            showSuccessMessage: true,
        }
    )
}

export function getProfile() {
    return createAxios({
        url: accountUrl + 'profile',
        method: 'get',
    })
}

export function postVerification(data: anyObj) {
    return createAxios({
        url: accountUrl + 'verification',
        method: 'post',
        data: data,
    })
}

export function postChangeBind(data: anyObj) {
    return createAxios(
        {
            url: accountUrl + 'changeBind',
            method: 'post',
            data: data,
        },
        {
            showSuccessMessage: true,
        }
    )
}

export function changePassword(params: anyObj) {
    return createAxios(
        {
            url: accountUrl + 'changePassword',
            method: 'POST',
            data: params,
        },
        {
            showSuccessMessage: true,
        }
    )
}

export function getBalanceLog(page: number, pageSize: number) {
    return createAxios({
        url: accountUrl + 'balance',
        method: 'GET',
        params: {
            page: page,
            limit: pageSize,
        },
    })
}

export function getIntegralLog(page: number, pageSize: number) {
    return createAxios({
        url: accountUrl + 'integral',
        method: 'GET',
        params: {
            page: page,
            limit: pageSize,
        },
    })
}

export function postLogout() {
    const userInfo = useUserInfo()
    return createAxios({
        url: userUrl + 'logout',
        method: 'POST',
        data: {
            refreshToken: userInfo.getToken('refresh'),
        },
    })
}

export function retrievePassword(params: anyObj) {
    return createAxios(
        {
            url: accountUrl + 'retrievePassword',
            method: 'POST',
            data: params,
        },
        {
            showSuccessMessage: true,
        }
    )
}

export function login(params: anyObj) {
    return createAxios(
        {
            url: userUrl + 'login',
            method: 'POST',
            data: params,
            headers: {
                'ba-user-token': 'undefined'
            }
        },
        {
            showSuccessMessage: true,
        }
    )
}

// 注册账号
export function register(params: anyObj) {
    return createAxios(
        {
            url: userUrl + 'register',
            method: 'POST',
            data: params,
        },
        {
            showSuccessMessage: true,
        }
    )
}

// mobile_login
export function mobileLogin(params: anyObj) {
    return createAxios(
        {
            url: userUrl + 'check_mobile_login',
            method: 'POST',
            data: params,
        },
        {
            showSuccessMessage: true,
        }
    )
}

export function getAccounts(params: anyObj) {
    return createAxios(
        {
            url: userUrl + 'get_accounts',
            method: 'POST',
            data: params,
        }
    )
}

// 验证码校验
export function captchaVerify(params: anyObj) {
    return createAxios({
        url: userUrl + 'check_retrieve_pwd',
        method: 'POST',
        data: params,
    })
}

// 修改密码
export function retrievePwd(params: anyObj) {
    return createAxios({
        url: userUrl + 'change_password',
        method: 'POST',
        data: params,
    })
}
// export function retrievePwd(params: anyObj) {
//     return createAxios({
//         url: userUrl + 'retrievePwd',
//         method: 'POST',
//         data: params,
//     })
// }

/* 
  忘记密码  发验证码
  请求示例：
  { "mobile": "18639618579" }

  响应示例：
  {
    "code": 1,
    "msg": "验证码已发送",
    "time": 1767765595,
    "data": {
        "mobile": "18639618579"
    }
}
*/
export function forgotSendCode(params: anyObj) {
    return createAxios({
        url: userUrl + 'forgot_send_code',
        method: 'POST',
        data: params,
    })
}
/* 
  忘记密码  校验验证码
  请求示例：
  { "mobile": "18639618579", "code": "621758" }

  响应示例：
  {
    "code": 1, // code不为1即验证不通过
    "msg": "验证通过",
    "time": 1767766133,
    "data": {
        "temp_token": "2c6feb9a6157bbb912d847ec79bf3347"
    }
}
*/
export function forgotVerifyCode(params: anyObj) {
    return createAxios({
        url: userUrl + 'forgot_verify_code',
        method: 'POST',
        data: params,
    })
}
/* 
  忘记密码 修改密码 
  请求示例：
  {
  "mobile": "18639618579",
  "temp_token": "5f18954d8d437096a459f0688d8166b5",
  "new_password": "123456",
  "confirm_password": "123456"
}
  响应示例
{
    "code": 1, // code不为1即修改失败
    "msg": "验证通过",
    "time": 1767766133,
    "data": null
*/
export function forgotResetPassword(params: anyObj) {
    return createAxios({
        url: userUrl + 'forgot_reset_password ',
        method: 'POST',
        data: params,
    })
}